import { useTranslation } from 'react-i18next'

import type { StatusConfig } from '../../components/StatusBadge'

export type ReturnStatus = 'REQUESTED' | 'APPROVED' | 'REJECTED' | 'REFUNDED'

const RETURN_STATUS_SET: ReadonlySet<string> = new Set<ReturnStatus>([
  'REQUESTED',
  'APPROVED',
  'REJECTED',
  'REFUNDED',
])

export function isReturnStatus(value: string): value is ReturnStatus {
  return RETURN_STATUS_SET.has(value)
}

export type ReturnStatusConfig = Record<ReturnStatus, StatusConfig>

export function useReturnStatusConfig(): ReturnStatusConfig {
  const { t } = useTranslation()

  return {
    REQUESTED: { color: 'orange', label: t('common.status.returnPending') },
    APPROVED: { color: 'green', label: t('common.status.returnApproved') },
    REJECTED: { color: 'red', label: t('common.status.returnRejected') },
    REFUNDED: { color: 'blue', label: t('common.status.returnRefunded') },
  }
}
